import styled from 'styled-components/macro'

import { theme, fluidSystem, OptionButtonInner, mediaHover } from 'styled'

export const Root = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  z-index: 3;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 54, 87, 0.5);
    z-index: -1;
  }
`

export const WelcomeBox = styled.div`
  ${fluidSystem};
  width: 100%;
  height: 100%;
  max-width: 630px;
  max-height: 785px;
  background-color: ${theme.colors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const Heading = styled.div`
  ${fluidSystem};
  display: flex;
  justify-content: space-between;
`
export const AnimationBox = styled.div`
  position: relative;
  width: 100%;
  flex: 999 0 50%;

  .Inner {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    video {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }
`
export const EnterButton = styled(OptionButtonInner)`
  align-self: flex-end;
  width: 150px;
`

export const CloseButton = styled.div`
  ${mediaHover`
    &:hover {
      cursor: pointer;
    }
  `};
`
